/**
 * Helpers purs pour déterminer si l'utilisateur connecté dispose d'un
 * droit d'accès effectif sur une application donnée .
 *
 * <p><b>Pourquoi</b> ( ticket bug ticket_507 ) : un utilisateur ne
 * possédant aucun rôle PG sur une application pouvait quand même
 * atterrir sur la page d'accueil de cette application en collant son
 * URL ( ex /applications/ticket_507 ) . Les sous-routes plantaient en
 * HTTP 500 ( cf {@code AuthorizationFilter.extractBinaryFileAndFindDataName}
 * + {@code ApplicationRepository.findApplication} qui lève
 * {@code NoSuchApplicationException} sous RLS ) , et l'UX exposait
 * uniquement une page vide / muette .
 *
 * <p><b>Règle métier</b> :
 * <ul>
 *   <li>{@code isOpenAdomAdmin = true} -&gt; accès total ( bypass RLS ) ;</li>
 *   <li>{@code applicationRoles} non-vide -&gt; au moins un rôle sur
 *       cette application ( {@code applicationManager} , {@code reader} ,
 *       etc ) ;</li>
 *   <li>sinon -&gt; aucun accès , afficher un placeholder explicite .</li>
 * </ul>
 *
 * <p><b>Note</b> sur {@code isApplicationCreator} : ce flag est
 * <i>global</i> ( droit de créer de NOUVELLES applications ) , pas
 * spécifique à l'application courante . Il ne doit PAS donner accès
 * automatique aux applications existantes . Un applicationCreator qui
 * crée une app reçoit automatiquement les rôles
 * {@code applicationManager / userManager / reader / writer} sur celle-ci ,
 * peuplant alors {@link CurrentApplicationUserRoles.applicationRoles} -
 * le check ci-dessous reste correct .
 */

export interface CurrentApplicationUserRoles {
  applicationRoles?: readonly string[] | null;
  isOpenAdomAdmin?: boolean | null;
}

/**
 * Vrai si l'utilisateur peut consulter / interagir avec l'application
 * ( au moins un rôle applicatif OU openAdomAdmin global ) .
 */
export function hasAnyApplicationAccess(
  roles: CurrentApplicationUserRoles | null | undefined,
): boolean {
  if (!roles) return false;
  if (roles.isOpenAdomAdmin) return true;
  const appRoles = roles.applicationRoles;
  return Array.isArray(appRoles) && appRoles.length > 0;
}
